import { render, staticRenderFns } from "./relateDetection.vue?vue&type=template&id=48048f9e&scoped=true&"
import script from "./relateDetection.vue?vue&type=script&lang=ts&"
export * from "./relateDetection.vue?vue&type=script&lang=ts&"
import style0 from "./relateDetection.vue?vue&type=style&index=0&id=48048f9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48048f9e",
  null
  
)

export default component.exports